var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('div',{staticClass:"d-flex flex-column min-vh-100"},[_c('ul',[_c('li',[_c('div',{staticClass:"mt-3"},[(JSON.stringify(this.objs)!=='{}')?_c('Jointable',{attrs:{"items":_vm.objs}}):_vm._e()],1)])]),_c('div',{staticClass:"wrapper flex-grow-1"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }